import {ICategoryDto} from './CategoryDto';

export interface ICategoriesDto {
    categories: ICategoryDto[] | null;
}

export class CategoriesDto implements ICategoriesDto {
    public categories: ICategoryDto[];
    constructor() {
        this.categories = new Array<ICategoryDto>();
    }
}